<template>
	<div :class="`scoreButton flex items-stretch`">
		<div :class="[`w-02 rounded-l-sm bg-score-${getScoreColor(score)}`, { '!bg-white': isLoading }]"></div>

		<Button variant="quaternary" size="s" icon="chart-box-outline" :loading="isLoading">
			<div class="flex items-center">
				<span>{{ t('saleDaysSummaryPanel.score') }}</span>
				<span :class="`ml-02 text-score-${getScoreColor(score)}`">{{ formatScore(score, 1) }}%</span>
			</div>
		</Button>
	</div>
</template>

<script setup lang="ts">
import { Button, useTranslation } from '@bluebrick/saas-ui'
import { formatScore, getScoreColor } from '@/common/utils'

const { t } = useTranslation()

defineProps<{
	score: number
	isLoading?: boolean
}>()
</script>
